import { departments } from "./_variable";

// The below code updates the e-mail in the contact-us container to match the html page and department.
ready(() => {
  const contactEmail1 = document.querySelector('#contact-us-email-1');
  const contactEmail2 = document.querySelector('#contact-us-email-2');
    
  if (!contactEmail1 || !contactEmail2) return;

  departments.forEach(d => {
    if (document.title.includes(d.name)) {
        contactEmail1.innerHTML = d.email;
        contactEmail1.parentElement.href = `mailto:${d.email}`;
        contactEmail2.parentElement.classList.add('d-none');
    } else {
        contactEmail1.innerHTML = 'exports@gpl-customs.co.uk';
        contactEmail1.parentElement.href = 'mailto:exports@gpl-customs.co.uk';
        contactEmail2.innerHTML = 'imports@gpl-customs.co.uk';
        contactEmail2.parentElement.href = 'mailto:imports@gp-logistics.co.uk';
    }
  });

});